import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
  timeout: 60000,
  headers: { "x-api-key": process.env.REACT_APP_BACKEND_API_KEY },
});

export default instance;
